import React from 'react';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';
import { useStyles, outlineUseStyles, textLabelUseStyles } from './ItemStatus.styled';
import i18n from 'i18n-js';
import clsx from 'clsx';
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';

const ItemStatus = ({ i18nKey, status, icon, label, variant = 'labelValue', iconStyles = {}, dataCy = 'status' }) => {
  const classes = useStyles();
  const outlineClasses = outlineUseStyles();
  const textLabelClasses = textLabelUseStyles();

  const styleMap = {
    standard: classes,
    outlined: outlineClasses,
    labelValue: textLabelClasses,
  };

  const styles = styleMap[variant] || classes;

  const getIcon = () => {
    if (icon === 'circle') {
      return <FiberManualRecordIcon style={iconStyles} className={styles[status?.toLowerCase()]} />;
    }
    return '';
  };

  return (
    <>
      {icon && getIcon(icon)}
      <Typography data-cy={dataCy} variant="inherit" className={clsx(styles.status, styles[status?.toLowerCase()])}>
        {variant === 'labelValue' && label && <span className={styles.label}>{`${label}: `}</span>}
        {i18n.t(`${i18nKey}.${status}`, { defaultValue: status || '' })}
        {variant !== 'labelValue' && label ? ' ' + label : ''}
      </Typography>
    </>
  );
};

ItemStatus.propTypes = {
  i18nKey: PropTypes.string,
  status: PropTypes.string,
  icon: PropTypes.string,
  label: PropTypes.string,
  variant: PropTypes.oneOf(['standard', 'outlined', 'labelValue']),
  iconStyles: PropTypes.object,
};

export default ItemStatus;
